export default __webpack_public_path__ + "static/media/ASU Foundational Principles.670d3bb4.webp";